var TabOccurrencesModule = /** @class */ (function () {
    function TabOccurrencesModule() {
    }
    return TabOccurrencesModule;
}());
export { TabOccurrencesModule };
